import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import {
    Aangifte,
    Adres, BokkzAlgDataService, IncomeTaxEntity,
    Lening,
    LeningAflossingsMethode,
    LeningGeldVerstrekker,
    OmschrijvingEnBedrag, Persoon
} from '@snelstart-ventures/fiscaal/domain-logic';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { BokkzIbDataService } from '@snelstart-ventures/fiscaal/domain-logic';
import { SelectFormControlItem, SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { optionsLandcodesMetNLD } from '../../../gedeelde-componenten/gedeelde-componenten.component';
import { filter, Subscription } from 'rxjs';
import { Event, NavigationEnd, Router } from '@angular/router';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiAlertModule } from '@snelstart/ui-alert';
import { SharedUiDialogModule } from '@snelstart/ui-dialog';
import { SharedUiButtonModule } from '@snelstart/ui-button';
import { CommonModule } from '@angular/common';


@Component({
    selector: 'snelstart-venture-fiscaal-feature-eigenwoning-schulden',
    templateUrl: './eigenwoning-schulden.component.html',
    imports: [
        SharedUiDetailsModule,
        SharedUiFormControlsModule,
        SharedUiAlertModule,
        SharedUiDialogModule,
        SharedUiButtonModule,
        CommonModule
    ],
    styleUrls: ['./eigenwoning-schulden.component.scss']
})
export class EigenwoningSchuldenComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isSaving = false;
    @Input() public id!: string;
    public clientId!: string;
    public incomeTaxEntity = {} as IncomeTaxEntity;
    private focusedElementId: string | null = null;

    public dialogVisible = false;

    public leningenFG = {} as FormGroup;

    showDialog(index: number) {
        this.index = index;
        this.dialogVisible = true;
    }

    public index = 0;

    public soortLeningGeldVerstrekker: SelectFormControlItem<string>[] = [
        { value: LeningGeldVerstrekker.BANK, label: 'Bank' },
        { value: LeningGeldVerstrekker.PENSIOENFONDS, label: 'Pensioenfonds' },
        { value: LeningGeldVerstrekker.VERZEKERAAR, label: 'Verzekeraar' },
        { value: LeningGeldVerstrekker.NIET_ADMINISTRATIEPLICHTIGE, label: 'Familie/Eigen BV' }
    ];

    public soortLeningAflossingsMethode: SelectFormControlItem<string>[] = [
        { value: LeningAflossingsMethode.ANNUITAIR, label: 'Annuïtair' },
        { value: LeningAflossingsMethode.LINEAIR, label: 'Lineair' },
        { value: LeningAflossingsMethode.OVERIG, label: 'Overig' }
    ];

    public optionsLandcodes: SelectFormControlItem<string>[] = optionsLandcodesMetNLD;

    constructor(private fb: FormBuilder, private router: Router, public dataService: BokkzIbDataService, private dataAlgService: BokkzAlgDataService) {
        this.leningenFG = this.fb.group({
            leningen: this.fb.array<Lening>([])
        });
    }

    //lening
    get leningen(): FormArray {
        return this.leningenFG.get('leningen') as FormArray;
    }

    addLening(): void {
        const lening = this.createLeningenFormGroup();
        this.leningen.push(lening);
    }

    deleteLening(index: number): void {
        this.handleDeleteInBox1(this.leningen.at(index).value.omschrijving, index);
        this.saveForm();
    }

    //kosten
    //aankoopkosten
    getKosten(index: number): FormArray {
        const outerGroup = this.leningen.at(index) as FormGroup;
        return outerGroup.get('kosten') as FormArray;
    }

    addKosten(index: number): void {
        const innerGroup = this.fb.group<OmschrijvingEnBedrag>({
            omschrijving: '',
            bedrag: undefined
        });
        const outerGroup = this.leningen.at(index) as FormGroup;
        const innerArray = outerGroup.get('kosten') as FormArray;
        innerArray.push(innerGroup);
    }

    deleteKosten(outerIndex: number, innerIndex: number): void {
        const innerArray = this.getKosten(outerIndex);
        innerArray.removeAt(innerIndex);
        this.saveForm();
    }

    createLeningenFormGroup(lening?: Lening): FormGroup {
        return this.fb.group({
                omschrijving: lening?.omschrijving || undefined,
                bedrag: lening?.bedrag || undefined,
                rekeningNummer: lening?.rekeningNummer || undefined,
                landCode: lening?.landCode || undefined,
                aanwending: lening?.aanwending || undefined,
                geldVerstrekker: lening?.geldVerstrekker || undefined,
                wozNummerWaarLeningBijHoort: lening?.wozNummerWaarLeningBijHoort || undefined,
                percentageBox1: lening?.percentageBox1 ?? undefined,
                hoofdsom0101: lening?.hoofdsom0101 ?? undefined,
                hoofdsom3112: lening?.hoofdsom3112 ?? undefined,
                rente: lening?.rente || undefined,
                kosten: this.fb.array<OmschrijvingEnBedrag>([]),
                personeelsKorting: lening?.personeelsKorting || undefined,
                aanvangsDatum: lening?.aanvangsDatum || undefined,
                eindDatum: lening?.eindDatum || undefined,
                oorspronkelijkeHoofdsom: lening?.oorspronkelijkeHoofdsom || undefined,
                rentePercentageDecimalen: lening?.rentePercentageDecimalen || undefined,
                aflossingsMethode: lening?.aflossingsMethode || undefined,
                naamLeninggever: this.fb.group<Persoon>({
                    roepnaam: lening ? lening.naamLeninggever?.roepnaam : undefined,
                    voorletters: lening ? lening.naamLeninggever?.voorletters : undefined,
                    tussenvoegsels: lening ? lening.naamLeninggever?.tussenvoegsels : undefined,
                    achternaam: lening ? lening.naamLeninggever?.achternaam || '' : '',
                    bsn: lening ? lening.naamLeninggever?.bsn : undefined,
                    geboortedatum: lening ? lening?.naamLeninggever?.geboortedatum : null as unknown as Date,
                    overlijdensdatum: lening ? lening.naamLeninggever?.overlijdensdatum : undefined,
                    landCodeNationaliteit: lening ? lening.naamLeninggever?.landCodeNationaliteit : undefined
                }),
                adresLeninggever: this.fb.group<Adres>({
                    straat: lening ? lening.adresLeninggever?.straat : undefined,
                    huisNummer: lening ? lening.adresLeninggever?.huisNummer : undefined,
                    huisNummerToevoeging: lening ? lening.adresLeninggever?.huisNummerToevoeging : undefined,
                    postcode: lening ? lening.adresLeninggever?.postcode : undefined,
                    woonplaats: lening ? lening.adresLeninggever?.woonplaats : undefined,
                    landCode: lening ? lening.adresLeninggever?.landCode : undefined
                })
            }
        );
    }

    public createOmschrijvingEnBedragFormGroup(omschrijving?: OmschrijvingEnBedrag): FormGroup {
        return this.fb.group(({
            omschrijving: omschrijving ? omschrijving.omschrijving : undefined,
            bedrag: omschrijving ? omschrijving.bedrag : undefined

        } as OmschrijvingEnBedrag));
    }

    formStructure: any;
    leningLength: any;

    public ngOnInit(): void {
        this.incomeTaxEntitySubscription = this.dataService.incomeTaxEntity.subscribe((incomeTaxEntity) => {
            this.incomeTaxEntity = incomeTaxEntity;
            if (incomeTaxEntity.aangifte) {
                this.updateForm();
            }
        });
        this.leningenFG.valueChanges.subscribe(value => {
            this.formStructure = value;
        });
        this.leningen.valueChanges.subscribe(value => {
            this.leningLength = value;
        });
        this.clientEntitySubscription = this.dataAlgService.client.subscribe((client) => {
            this.clientId = client.sstRelationId!;
        });
        this.routerSubscription = this.router.events
            .pipe(filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.handleUrlChange(event.urlAfterRedirects);
            });
    }

    ngOnDestroy(): void {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe(); // Unsubscribe to avoid memory leaks
        }
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe();
        }
        if (this.clientEntitySubscription) {
            this.clientEntitySubscription.unsubscribe();
        }
    }

    handleUrlChange(newUrl: string) {
        if (!this.isSaving && this.hasUnsavedChanges()) {
            this.isSaving = true;
            this.dataService.postIncomeTaxEntity(this.clientId, false, this.incomeTaxEntity);
            this.isSaving = false;
        }
    }

    private hasUnsavedChanges(): boolean {
        return this.leningenFG.dirty;
    }

    handleDeleteInBox1(originalOmschrijving: string, index: number) {
        const omschrijvingInBox3 = `Box 3-deel ${originalOmschrijving}`;

        const indexInBox3 = this.incomeTaxEntity?.aangifte?.box3?.leningen?.findIndex(
            (lening) => lening.omschrijving === omschrijvingInBox3
        ) ?? -1;

        if (indexInBox3 !== -1) {
            this.incomeTaxEntity!.aangifte!.box3!.leningen!.splice(indexInBox3, 1);
        }

        this.leningen.removeAt(index);
        this.leningenFG.updateValueAndValidity();
        this.leningenFG.markAsDirty();
    }

    private updateForm(): void {
        const leningenLijst = this.incomeTaxEntity.aangifte?.box1?.belastbareInkomstenUitEigenWoning?.leningen || [];
        const formArray = this.leningenFG.get('leningen') as FormArray;
        const focusedControl = this.focusedElementId ? document.getElementById(this.focusedElementId) as HTMLElement : null;

        while (formArray.length > leningenLijst.length) {
            formArray.removeAt(formArray.length - 1);
        }

        // Update leningen
        for (let i = 0; i < leningenLijst.length; i++) {
            const lening = leningenLijst[i];
            if (lening.adresLeninggever?.postcode) {
                lening.adresLeninggever.postcode = this.formatPostcode(lening.adresLeninggever.postcode);
            }

            if (i < formArray.length) {
                const control = formArray.at(i) as FormGroup;
                control.patchValue(leningenLijst[i]);
            } else {
                const formGroup = this.createLeningenFormGroup(leningenLijst[i]);
                formArray.push(formGroup);
            }
        }

        // Update kosten lening (k)
        for (let i = 0; i < leningenLijst.length; i++) {
            const lening = leningenLijst[i];
            const kosten = lening.kosten || [];
            const kostenFormArray = this.getKosten(i);

            while (kostenFormArray.length > kosten.length) {
                kostenFormArray.removeAt(kostenFormArray.length - 1);
            }
            for (let k = 0; k < kosten.length; k++) {
                if (k < kostenFormArray.length) {
                    const control = kostenFormArray.at(k) as FormGroup;
                    control.patchValue(kosten[k]);
                } else {
                    const kost = this.createOmschrijvingEnBedragFormGroup(kosten[k]);
                    kostenFormArray.push(kost);
                }
            }
        }

        if (focusedControl && document.contains(focusedControl)) {
            focusedControl.focus();
        }
    }

    saveForm(): void {
        setTimeout(() => {
            this.incomeTaxEntity.aangifte = {
                ...this.incomeTaxEntity.aangifte,
                box1: {
                    ...this.incomeTaxEntity.aangifte?.box1,
                    belastbareInkomstenUitEigenWoning: {
                        ...this.incomeTaxEntity.aangifte?.box1?.belastbareInkomstenUitEigenWoning,
                        leningen: this.leningenFG.getRawValue().leningen
                    }
                }
            } as Aangifte;
            this.dataService.updateIncomeTaxEntity(this.incomeTaxEntity);
        }, 0);
    }

    protected readonly LeningGeldVerstrekker = LeningGeldVerstrekker;

    hasPercentageBox1LessThan100(): boolean {
        return this.leningen.controls.some(control => {
            const percentage = control.get('percentageBox1')?.value;
            if (percentage != null) {
                return percentage >= 0 && percentage < 100;
            }
            else return false
        });
    }

    isAanvangsdatumNa2012(date: string | Date | null | undefined): boolean {
        if (!date) return false; // Geen datum? Dan tonen we niets

        const datum = new Date(date); // Zet om naar een Date-object
        return datum.getFullYear() > 2012;
    }

    formatPostcode(postcode: string | null | undefined): string {
        if (!postcode) return ''; // Retourneer een lege string als postcode null of undefined is

        // Verwijder alle niet-alfanumerieke tekens (bijv. spaties)
        const cleanedPostcode = postcode.replace(/[^a-zA-Z0-9]/g, '');

        // Zorg voor 4 cijfers en 2 hoofdletters
        if (cleanedPostcode.length >= 4) {
            const cijfers = cleanedPostcode.substring(0, 4).replace(/\D/g, ''); // Alleen cijfers
            const letters = cleanedPostcode.substring(4, 6).replace(/[^a-zA-Z]/g, '').toUpperCase(); // Alleen letters
            return `${cijfers}${letters}`;
        }

        return cleanedPostcode; // Als de postcode te kort is, retourneer de schoongemaakte versie
    }

    isLeningAtIndexValid(index: number): boolean {
        if (!this.leningen || index < 0 || index >= this.leningen.length) {
            return false;
        }

        const leningFormGroup = this.leningen.at(index) as FormGroup;
        const geldVerstrekker = leningFormGroup.get('geldVerstrekker')?.value;

        if (geldVerstrekker === LeningGeldVerstrekker.NIET_ADMINISTRATIEPLICHTIGE) {
            const aanvangsDatum = leningFormGroup.get('aanvangsDatum')?.value;
            const eindDatum = leningFormGroup.get('eindDatum')?.value;
            const oorspronkelijkeHoofdsom = leningFormGroup.get('oorspronkelijkeHoofdsom')?.value;
            const rentePercentageDecimalen = leningFormGroup.get('rentePercentageDecimalen')?.value;
            const aflossingsMethode = leningFormGroup.get('aflossingsMethode')?.value;

            return !!(
                aanvangsDatum &&
                eindDatum &&
                oorspronkelijkeHoofdsom !== undefined &&
                rentePercentageDecimalen !== undefined &&
                aflossingsMethode
            );
        }
        return true;
    }

    get isCurrentLeningValid(): boolean {
        return this.isLeningAtIndexValid(this.index);
    }

    isFirstNietAdminPlichtige(index: number): boolean {
        for (let i = 0; i < index; i++) {
            if (this.leningen.at(i).value.geldVerstrekker === LeningGeldVerstrekker.NIET_ADMINISTRATIEPLICHTIGE) {
                return false;
            }
        }
        return true;
    }
}
